import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Modal from 'react-modal';

import '../optimisation-dashboard/optimisation-dashboard.scss';
import { DashboardHeader } from '../../atoms';
import { DashContainer, DashContentFooter, OptimisationContainer } from '../../molecules';
import { DashboardContext, UserContext } from '../../../context';
import ReportsContainer from '../../molecules/reports-container/reports-container';

function GenerateReports() {
  const [dashData, setDashData] = useState({});

  return (
    <DashboardContext.Provider value={{ dashData, setDashData }}>
      <div className="row no-gutters">
        <div className="no-gutters dash-left-wrapper">
          <DashboardHeader />
          <ReportsContainer />
          <DashContentFooter className="footer-margin" />
        </div>
      </div>
    </DashboardContext.Provider>
  );
}

export default GenerateReports;
